import { Box } from '@mui/material'
import { WorkInstructionStatus } from '@operations/app/api'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, ColorSchema, useMinimalsTheme } from '@tom-ui/ui'
import { useMemo } from 'react'

interface Props {
  status: WorkInstructionStatus
}
export const WorkInstructionStatusChip = ({ status }: Props) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const currentStatus: { label: string; color: ColorSchema } = useMemo(() => {
    switch (status) {
      case WorkInstructionStatus.InProgress:
        return { label: t('inProgress', 'In progress'), color: 'busy' }
      case WorkInstructionStatus.Finished:
        return { label: t('finished', 'Finished'), color: 'success' }
      case WorkInstructionStatus.WaitingForStackIn:
        return { label: t('waitingForStackIn', 'Waiting for stack in'), color: 'success' }
      case WorkInstructionStatus.Pending:
        return { label: t('pending', 'Pending'), color: 'info' }
      case WorkInstructionStatus.Stopped:
        return { label: t('stopped', 'Stopped'), color: 'warning' }

      default:
      case WorkInstructionStatus.Todo:
        return { label: t('toDo', 'To do'), color: 'info' }
    }
  }, [status, t])

  return (
    <Box data-cy='carrier-visit-status-chip'>
      <ColoredLabel
        label={currentStatus.label}
        color={currentStatus.color}
        sx={{
          width: 'fit-content',
          backgroundColor: theme.palette[currentStatus.color].lighter,
        }}
      />
    </Box>
  )
}
